<template>
  <div class="site-wrap" v-if="!$route.query.page || ($route.query.page && token)">
    <div class="site-mobile-menu site-navbar-target">
      <div class="site-mobile-menu-header">
        <div class="site-mobile-menu-close">
          <span class="icon-close2 js-menu-toggle"></span>
        </div>
      </div>
      <div class="site-mobile-menu-body"></div>
    </div>

    <NavBar @login="goLogin" @register="register" />

    <section class="home-section bg-dark overlay" id="home-section">
      <div class="ban">
        <div class="container"></div>
      </div>
    </section>

    <section class="site-section" style="overflow: hidden">
      <div class="row" style="overflow-y: hidden">
        <div class="col-lg-6 col-sm-12 col-md-12">
          <div class="card1">
            <div class="card-body">
              <b-row>
                <b-col lg="4" md="4" sm="12">
                  <b-button class="ml-3" variant="white" :to="`/`">
                    <b>
                      <i class="fa fa-arrow-left"></i>
                      {{ $t("actions.back") }}
                    </b>
                  </b-button>
                </b-col>
                <h4 class="ml-5">
                  <b>{{ $t("home.vacancies") }}</b>
                </h4>
              </b-row>
              <div v-if="totalVacancy > 0">
                <main>
                  <ol class="gradient-list">
                    <li
                      v-for="(vacancies, key) in listVacancy"
                      :key="key"
                      @click="openVanacyDetails(vacancies)"
                      class="current"
                      :style="
                        vacancies.selected === true
                          ? 'background: rgb(52 58 64 / 35%);'
                          : ''
                      "
                    >
                      <div class="pagination-circle-inner">
                        <strong> {{ key + 1 }}</strong>
                      </div>
                      <a href="#">
                        <b-row>
                          <b-col cols="9">
                            <h6>
                              {{ vacancies[$localeKey("staffPositionName")] }}
                            </h6>
                            <span
                              style="
                                background: #ffb700;
                                border-radius: 4px;
                                padding: 2px;
                                color: white;
                                font-size: 12px;
                              "
                            >
                              {{ vacancies[$localeKey("directoryDepartmentName")] }}
                            </span>
                          </b-col>
                          <b-col cols="3">
                            <b-badge class="float-right" variant="primary">
                              {{ $t("home.nomzod") }}
                              <b-badge class="ml-1" variant="light">
                                <span style="font-size: 14px">{{
                                  vacancies.countOfVacancy === null
                                    ? 0
                                    : vacancies.countOfVacancy
                                }}</span>
                              </b-badge>
                            </b-badge>
                          </b-col>
                        </b-row>
                      </a>
                    </li>
                  </ol>
                </main>
              </div>
              <div v-else>{{ $t("warning.noInformation") }}</div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-sm-12 col-md-12">
          <div class="card2 mt-3 ml-2 mr-2">
            <div class="card-body" v-if="getTitleByCode()">
              <div v-html="getTitleByCode('instruction')[$localeKey()]"></div>
              <hr />
              <br />
              <div class="hello">
                <yandex-map
                  :scrollZoom="false"
                  zoom="5"
                  style="width: 100%; max-width: 100%; height: 50vh"
                  :coords="coords"
                >
                  <ymap-marker
                    marker-type="placemark"
                    :coords="[coordinate.latitude, coordinate.longitude]"
                    marker-id="123"
                  ></ymap-marker>
                </yandex-map>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-sidebar
        v-model="detailModal"
        right
        shadow
        width="50em"
        id="sidebar-right"
        backdrop
        no-header
      >
        <div>
          <b-overlay
            :show="loader"
            spinner-variant="primary"
            rounded="sm"
            variant="transparent"
          >
            <b-card no-body class>
              <div class="card-body p-0 m-3 mt-0 mb-0">
                <b-card>
                  <b-row>
                    <b-col lg="3" xs="3">
                      <img
                        :src="require('@/assets/img/doc.jpg')"
                        alt
                        style="height: 90px; width: 100px"
                      />
                    </b-col>
                    <b-col lg="9" xs="9">
                      <h2 class="mt-3 text-center">
                        <b>
                          {{ $t("home.aboutLavozim") }}
                          <br />
                          {{ $t("home.aboutAll") }}
                        </b>
                      </h2>
                    </b-col>
                  </b-row>
                </b-card>
                <b-card>
                  <b-row class="mt-1">
                    <b-col lg="1" xs="12">
                      <h4 class="textColor">
                        <i class="fab fa-artstation"></i>
                      </h4>
                    </b-col>
                    <b-col lg="5" xs="12">
                      <h4 class="textColor">
                        <b style="font-size: 20px">{{ $t("org") }}</b>
                      </h4>
                    </b-col>
                    <b-col lg="6" xs="12" class="text-left">
                      <b>
                        <p class="pt-1" style="color: #025dfa; font-size: 14px">
                          {{ detailByIdVacancy.depNameLt }}
                        </p>
                      </b>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="1" xs="12">
                      <h4 class="textColor">
                        <i class="fas fa-code-branch"></i>
                      </h4>
                    </b-col>
                    <b-col lg="5" xs="12">
                      <h4 class="textColor">
                        <b style="font-size: 20px">{{ $t("home.bolim") }}</b>
                      </h4>
                    </b-col>
                    <b-col lg="6" xs="12" class="text-left">
                      <b>
                        <p class="pt-1" style="color: #025dfa; font-size: 14px">
                          {{ detailByIdVacancy.directoryDepartmentNameLt }}
                        </p>
                      </b>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="1" sm="12">
                      <h4 class="textColor">
                        <i class="fas fa-layer-group"></i>
                      </h4>
                    </b-col>
                    <b-col lg="5" sm="12">
                      <h4 class="textColor">
                        <b style="font-size: 20px">{{ $t("home.lavozimToifa") }}</b>
                      </h4>
                    </b-col>
                    <b-col lg="5" sm="12" class="text-left">
                      <b>
                        <p class="pt-1" style="color: #025dfa; font-size: 14px">
                          {{ detailByIdVacancy.typePositionNameLt }}
                        </p>
                      </b>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="1" xs="12">
                      <h4 class="textColor">
                        <i class="fas fa-user-tie"></i>
                      </h4>
                    </b-col>
                    <b-col lg="5" xs="12">
                      <h4 class="textColor">
                        <b style="font-size: 20px">{{ $t("home.lavozim") }}</b>
                      </h4>
                    </b-col>
                    <b-col lg="6" xs="12" class="text-left">
                      <b>
                        <p class="pt-1" style="color: #025dfa; font-size: 14px">
                          {{ detailByIdVacancy.staffPositionNameLt }}
                        </p>
                      </b>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="1" xs="12">
                      <h4 class="textColor">
                        <i class="fas fa-bullhorn"></i>
                      </h4>
                    </b-col>
                    <b-col lg="5" xs="12">
                      <h4 class="textColor">
                        <b style="font-size: 20px">{{ $t("home.jobOn") }}</b>
                      </h4>
                    </b-col>
                    <b-col lg="6" xs="12" class="text-left">
                      <b>
                        <p class="pt-1" style="color: #025dfa; font-size: 14px">
                          {{ detailByIdVacancy.vacancy }}
                        </p>
                      </b>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="1" xs="12">
                      <h4 class="textColor">
                        <i class="fas fa-hourglass-start"></i>
                      </h4>
                    </b-col>
                    <b-col lg="5" xs="12">
                      <h4 class="textColor">
                        <b style="font-size: 20px">{{ $t("home.createDate") }}</b>
                      </h4>
                    </b-col>
                    <b-col lg="6" xs="12" class="text-left">
                      <b>
                        <p class="pt-1" style="color: #025dfa; font-size: 14px">
                          {{ this.detailByIdVacancy.sendDate }}
                        </p>
                      </b>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="1" xs="12">
                      <h4 class="textColor">
                        <i class="fas fa-hourglass-end"></i>
                      </h4>
                    </b-col>
                    <b-col lg="5" xs="12">
                      <h4 class="textColor">
                        <b style="font-size: 20px">{{ $t("home.finishDate") }}</b>
                      </h4>
                    </b-col>
                    <b-col lg="6" xs="12" class="text-left">
                      <b>
                        <p class="pt-1" style="color: #025dfa; font-size: 14px">
                          {{ detailByIdVacancy.expireDate }}
                        </p>
                      </b>
                    </b-col>
                  </b-row>
                </b-card>
              </div>

              <div class="wrap">
                <img
                  style="width: 50px"
                  :src="require('@/assets/down-chevron.png')"
                  id="arrow"
                  class="animated bounce"
                />
              </div>
              <!--              <div c class="arrow-container animated fadeInDown">-->
              <!--                <div class="arrow-2">-->
              <!--                  <i class="fa fa-angle-down"></i>-->
              <!--                </div>-->
              <!--                <div class="arrow-1 animated hinge infinite zoomIn"></div>-->
              <!--              </div>-->
            </b-card>
          </b-overlay>

          <div>
            <b-card>
              <div class="text-center">
                <b>{{ $t("staff_requirement_1") }}</b>
              </div>
              <div class="p-2 mr-3 ml-3">
                <p class="requirement" v-html="requirementByIdVacancy[$localeKey()]"></p>
              </div>
              <br />
              <div class="text-center">
                <b>{{ $t("staff_requirement_2") }}</b>
              </div>
              <div class="p-2 mr-3 ml-3">
                <p
                  class="requirement"
                  v-html="requirementByIdVacancy[$localeKey('requirementName')]"
                ></p>
              </div>
            </b-card>
          </div>
          <div>
            <b-card>
              <b-card-header class="bg-white p-1">
                <h5 class="text-center text-wrap mt-0">
                  <b>
                    {{ $t("with_me") }}
                    <br />
                  </b>
                </h5>
              </b-card-header>
              <div class="m-3 p-3">
                <b-card-group deck>
                  <b-card border-variant="success" bg-variant="light" class="text-center">
                    <div style="text-align: center">
                      <img
                        :src="require('@/assets/img/office.png')"
                        alt
                        style="height: 90px; width: 100px"
                      />
                    </div>
                    <b-card-text class="text-center mt-2">
                      {{ $t("staff_requirement_card_1") }}
                    </b-card-text>
                  </b-card>
                  <b-card border-variant="success" bg-variant="light" class="text-center">
                    <div style="text-align: center">
                      <img
                        :src="require('@/assets/img/team.png')"
                        alt
                        style="height: 90px; width: 100px"
                      />
                    </div>
                    <b-card-text class="text-center mt-2">
                      {{ $t("staff_requirement_card_2") }}
                    </b-card-text>
                  </b-card>
                </b-card-group>
              </div>
              <div class="m-3 p-3">
                <b-card-group deck>
                  <b-card border-variant="success" bg-variant="light" class="text-center">
                    <div style="text-align: center">
                      <img
                        :src="require('@/assets/img/salary.png')"
                        alt
                        style="height: 90px; width: 100px"
                      />
                    </div>
                    <b-card-text class="text-center mt-2">
                      {{ $t("staff_requirement_card_3") }}
                    </b-card-text>
                  </b-card>
                  <b-card border-variant="success" bg-variant="light" class="text-center">
                    <div style="text-align: center">
                      <img
                        :src="require('@/assets/img/career.png')"
                        alt
                        style="height: 90px; width: 100px"
                      />
                    </div>
                    <b-card-text class="text-center mt-2">
                      {{ $t("staff_requirement_card_4") }}
                    </b-card-text>
                  </b-card>
                </b-card-group>
              </div>
              <div class="m-3 p-3">
                <b-card-group deck>
                  <b-card border-variant="success" bg-variant="light" class="text-center">
                    <div style="text-align: center">
                      <img
                        :src="require('@/assets/img/tajriba.jpg')"
                        alt
                        style="height: 90px; width: 100px"
                      />
                    </div>
                    <b-card-text class="text-center mt-2">
                      {{ $t("staff_requirement_card_5") }}
                    </b-card-text>
                  </b-card>
                  <b-card border-variant="success" bg-variant="light" class="text-center">
                    <div style="text-align: center">
                      <img
                        :src="require('@/assets/img/travel.png')"
                        alt
                        style="height: 90px; width: 100px"
                      />
                    </div>
                    <b-card-text class="text-center mt-2">
                      {{ $t("staff_requirement_card_6") }}
                    </b-card-text>
                  </b-card>
                </b-card-group>
              </div>
            </b-card>
          </div>
        </div>

        <template #footer="">
          <div class="d-flex text-light align-items-center py-lg-2 mt-2 mb-2 px-lg-2">
            <b-button style="width: 40%" variant="danger" block @click="hideSidebar">{{
              $t("home.close")
            }}</b-button>
            <b-button
              style="width: 60%"
              variant="primary"
              :disabled="detailByIdVacancy.selected"
              block
              @click="apply"
              class="ml-2 mb-2"
            >
              {{ $t("home.sendDocument") }}
            </b-button>
          </div>
        </template>
      </b-sidebar>
    </section>
    <b-modal
      :no-close-on-backdrop="true"
      :ok-title="$t('register.title')"
      :cancel-title="$t('actions.cancel')"
      :ok-variant="'outline-primary'"
      :cancel-variant="'danger'"
      @ok="okModal"
      @cancel="authModal = false"
      hide-header
      v-model="authModal"
      centered
    >
      <b-form class="form" style="width: 100%">
        <b-form-group id="example-input-group-1" label label-for="example-input-1">
          <label>{{ $t("login.username") }}</label>
          <b-form-input
            @keyup.enter="onSubmit"
            autocomplete="off"
            style="padding: 14px"
            class="form-control form-control-solid h-auto"
            id="example-input-1"
            name="example-input-1"
            v-model.trim="$v.form.username.$model"
            aria-describedby="input-1-live-feedback"
            :state="validateState('username')"
            :placeholder="$t('login.username')"
          ></b-form-input>

          <b-form-invalid-feedback id="input-1-live-feedback">{{
            $t("error.name_error")
          }}</b-form-invalid-feedback>
        </b-form-group>

        <b-form-group id="example-input-group-2" label label-for="example-input-2">
          <label>{{ $t("login.password") }}</label>
          <b-form-input
            style="padding: 14px"
            @keyup.enter="onSubmit"
            class="form-control form-control-solid h-auto"
            type="password"
            id="example-input-2"
            name="example-input-2"
            :placeholder="$t('login.password')"
            v-model="$v.form.password.$model"
            :state="validateState('password')"
            aria-describedby="input-2-live-feedback"
          ></b-form-input>

          <b-form-invalid-feedback id="input-2-live-feedback">{{
            $t("error.name_error")
          }}</b-form-invalid-feedback>
          <b-input-group-append v-if="form.password">
            <b-button variant="outline-primary" @click="showPswd"
              ><i class="fa fa-eye"></i
            ></b-button>
          </b-input-group-append>
        </b-form-group>

        <!--begin::Action-->
        <div
          class="form-group d-flex flex-wrap justify-content-between align-items-center"
        >
          <b-button
            block
            variant="primary"
            @click.prevent="onSubmit"
            ref="kt_login_signin_submit"
            class="btn float-right p-3 mt-3"
            >{{ $t("login.come_out") }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <b-modal
      :no-close-on-backdrop="true"
      :hide-header="true"
      @close="cancel"
      @cancel="cancel"
      v-model="isModal"
    >
      <template v-slot:modal-footer>
        <b-button @click="cancel">
          {{ $t("actions.no") }}
        </b-button>
        <b-button @click="ok" :disabled="loaderDoc" variant="primary">
          <b-overlay :show="loaderDoc" :opacity="0.1" rounded="sm">
            {{ $t("actions.yes") }}
          </b-overlay>
        </b-button>
      </template>
      <p>{{ $t("login.verify") }}</p>
    </b-modal>
  </div>
  <Auth @login="loginFromVacancy" @register="registerFromVacancy" v-else />
</template>

<script>
import { yandexMap, ymapMarker } from "vue-yandex-maps";
import { mapActions, mapGetters, mapState } from "vuex";
import EmployeeService from "@/services/employee.service";
import { TokenService } from "@/services/storage.service";
import NavBar from "@/views/NavBar.vue";
import { bus } from "@/main";
import Auth from "@/components/Auth/auth";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  validations: {
    form: {
      username: {
        required,
      },

      password: {
        required,
      },
    },
  },
  name: "vacancy",
  components: {
    Auth,
    yandexMap,
    ymapMarker,
    NavBar,
  },
  computed: {
    ...mapState("ennounsment", {
      listVacancy: "listVacancy",
      coordinate: "coordinate",
      totalVacancy: "totalVacancy",
    }),
    ...mapState("employee", ["employee"]),
    ...mapState("auth", ["token"]),
    ...mapGetters("title", ["getTitleByCode"]),
  },
  data() {
    return {
      loaderDoc: false,
      form: {
        username: "",
        password: "",
      },
      selectedVacancy: null,
      isModal: false,
      isLog: false,
      isReg: false,
      loader: false,
      detailByIdVacancy: "",
      requirementByIdVacancy: {},
      current: null,
      detailModal: false,
      vacancyList: [],
      authModal: false,
      data: {
        page: 0,
        limit: 100,
      },
      coords: [41.3114937, 69.2768973],
    };
  },
  methods: {
    ...mapActions("ennounsment", {
      getListVacancy: "getListVacancy",
      getVacancyListIn: "getVacancyListIn",
    }),
    ...mapActions(["addDetail"]),
    ...mapActions("employee", ["getEmployee"]),
    ...mapActions("auth", ["login"]),
    cancel() {
      this.isModal = false;
    },
    ok(v) {
      if (this.token && this.employee) {
        this.loaderDoc = true;
        EmployeeService.selectVakant(this.selectedVacancy.id)
          .then((res) => {
            this.$toast.success(this.$t("succes.SEND_DOCUMENT"));
            TokenService.setselectedVacancy(null);
            this.$router.push("/profile");
          })
          .catch((e) => {
            let res = JSON.parse(e.request.response);
            if (res.details[0]) {
              this.isModal = false;
              this.detailModal = false;
              this.$toast.error(res.details[0], { timeout: 10000 });
            } else {
              this.isModal = false;
              this.detailModal = false;
              this.$toast.info(this.$t("warning.warInfo"));
            }
          })
          .finally(() => {
            this.loaderDoc = false;
          });
        // this.$store.commit(
        //     "vacancy/setSelectedVacancyOK",
        //     {detail: this.selectedVacancyOK, value: 'NO'}
        // );
      } else {
        this.$toast.info(this.$t("warning.loginInfo"));
        this.authModal = true;
      }
    },
    showPswd() {
      var x = document.getElementById("example-input-2");
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    goLogin() {
      if (this.$route.query.page != "login") {
        this.$router.push({
          path: "/",
          query: {
            page: "login",
          },
        });
      }
    },
    register() {
      if (this.$route.query.page != "register") {
        this.$router.push({
          path: "/",
          query: {
            page: "register",
          },
        });
      }
    },
    loginFromVacancy() {
      if (this.$route.query.page != "login") {
        this.$router.push({
          path: `/vacancy/${this.$route.params.id}`,
          query: {
            page: "login",
            vId: this.detailByIdVacancy.id,
          },
        });
      }
    },

    registerFromVacancy() {
      if (this.$route.query.page != "register") {
        this.$router.push({
          path: `/vacancy/${this.$route.params.id}`,
          query: {
            page: "register",
            vId: this.detailByIdVacancy.id,
          },
        });
      }
    },

    apply() {
      this.isModal = true;
      // if (this.token && this.employee) {
      //   this.$bvModal
      //       .msgBoxConfirm( this.$t( "login.verify" ), {
      //         size: "sm",
      //         buttonSize: "lg",
      //         okVariant: "success",
      //         okTitle: this.$t( "actions.yes" ),
      //         cancelTitle: this.$t( "actions.no" ),
      //         footerClass: "p-2",
      //         hideHeaderClose: false,
      //         centered: true
      //       } )
      //       .then( value => {
      //         if (value) {
      //           EmployeeService.selectVakant( this.detailByIdVacancy.id )
      //               .then( res => {
      //
      //                 this.$toast.success( this.$t( "succes.SEND_DOCUMENT" ) );
      //                 TokenService.setselectedVacancy( null )
      //                 this.$router.push( "/profile" );
      //               } )
      //               .catch( e => {
      //                 if (e.request.response == "selected") {
      //                   this.$toast.info( this.$t( "warning.selectInfo" ) );
      //                 } else {
      //                   this.$toast.info( this.$t( "warning.warInfo" ) );
      //                   this.$router.push( "/profile" );
      //                 }
      //               } );
      //         }
      //       } );
      // } else {
      //   this.$toast.info( this.$t( "warning.loginInfo" ) );
      //   this.authModal = true;
      // }
    },
    okModal(b) {
      b.preventDefault();
      this.registerFromVacancy();
      this.authModal = false;
    },
    async addCards() {
      this.$router.push("/");
    },
    async openVanacyDetails(detail) {
      console.log(detail);
      if (detail.selected) {
        this.$toast("Bu e'longa hujjat topshirgansiz");
        return;
      }
      if (this.$route.query.archive) {
        this.$toast.error("E'lon muddati tugagan!");
        return;
      }
      this.detailModal = true;
      this.selectedVacancy = detail;
      let res = await EmployeeService.getByRequirement(detail.staffListId);
      this.detailByIdVacancy = detail;
      const wordsnameLt = res.data[0].nameLt.split("\n");
      let nameLt = "";
      for (let i = 0; i < wordsnameLt.length; i++) {
        nameLt += wordsnameLt[i] + "<br>";
      }
      res.data[0].nameLt = nameLt;

      const wordsnameRu = res.data[0].nameRu.split("\n");
      let nameRu = "";
      for (let i = 0; i < wordsnameRu.length; i++) {
        nameRu += wordsnameRu[i] + "<br>";
      }
      res.data[0].nameRu = nameRu;

      const wordsnameUz = res.data[0].nameUz.split("\n");
      let nameUz = "";
      for (let i = 0; i < wordsnameUz.length; i++) {
        nameUz += wordsnameUz[i] + "<br>";
      }
      res.data[0].nameUz = nameUz;

      const wordsrequirementNameLt = res.data[0].requirementNameLt.split("\n");
      let requirementNameLt = "";
      for (let i = 0; i < wordsrequirementNameLt.length; i++) {
        requirementNameLt += wordsrequirementNameLt[i] + "<br>";
      }
      res.data[0].requirementNameLt = requirementNameLt;

      const wordsrequirementNameRu = res.data[0].requirementNameRu.split("\n");
      let requirementNameRu = "";
      for (let i = 0; i < wordsrequirementNameRu.length; i++) {
        requirementNameRu += wordsrequirementNameRu[i] + "<br>";
      }
      res.data[0].requirementNameRu = requirementNameRu;

      const wordsrequirementNameUz = res.data[0].requirementNameUz.split("\n");
      let requirementNameUz = "";
      for (let i = 0; i < wordsrequirementNameUz.length; i++) {
        requirementNameUz += wordsrequirementNameUz[i] + "<br>";
      }
      res.data[0].requirementNameUz = requirementNameUz;

      this.requirementByIdVacancy = res.data[0];

      this.current = detail.id;
      this.loader = true;

      if (detail !== null) {
        await setTimeout(() => {
          this.detailModal = true;
          this.loader = false;
        }, 500);

        let selectedVacancyId = {
          id: detail.id,
          staffPositionNameLt: detail.staffPositionNameLt,
          staffPositionNameRu: detail.staffPositionNameRu,
          staffPositionNameUz: detail.staffPositionNameUz,
        };
        TokenService.setselectedVacancy(selectedVacancyId);
      }
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      const username = this.$v.form.username.$model;
      const password = this.$v.form.password.$model;
      const submitButton = this.$refs["kt_login_signin_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(async () => {
        this.login({
          username: username,
          password: password,
        }).then((res) => {
          submitButton.classList.remove("spinner", "spinner-light", "spinner-right");
          this.$toast.success("Успешный вход в систему");
          this.authModal = false;
          this.detailModal = false;
          window.location.reload();
        });
      }, 1000);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    hideSidebar() {
      this.detailModal = false;
    },
    backAnnounsmentPage() {
      // this.$router.push("/");
    },
  },
  created() {
    if (this.token) {
      this.getVacancyListIn({ id: this.$route.params.id, data: this.data });
      this.getEmployee();
    } else {
      this.getListVacancy({ id: this.$route.params.id, data: this.data });
    }
  },
};
</script>

<style lang="scss" scoped>
.card1 {
  overflow-x: scroll;
  height: 100vh;
  margin-left: 15px;
  margin-top: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.card2 {
  overflow-x: scroll;
  height: 100vh;
  margin-top: 15px;
  margin-right: 15px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

//@import url(https://fonts.googleapis.com/css?family=Montserrat:900|Raleway:400,400i,700,700i);

/*** VARIABLES ***/
/* Colors */
$black: #1d1f20;
$blue: #83e4e2;
$green: #a2ed56;
$yellow: #fddc32;
$white: #fafafa;

/*** EXTEND ***/
/* box-shadow */
%boxshadow {
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0, 0, 0, 0.05),
    0 0.5rem 1.125rem rgba(75, 0, 0, 0.05);
}

/*** STYLE ***/
*,
*:before,
*:after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  background-color: $white;
  color: $black;
  font-family: "Raleway", sans-serif;
}

main {
  display: block;
  margin: 0 auto;
  width: 100%;
  padding: 1rem;
}

ol.gradient-list {
  width: 100%;
  counter-reset: gradient-counter;
  list-style: none;
  margin: 1rem 0;
  padding-left: 1rem;

  > li {
    background: white;
    border-radius: 0 0.5rem 0.5rem 0.5rem;
    @extend %boxshadow;
    counter-increment: gradient-counter;
    margin-top: 1rem;
    min-height: 1rem;
    padding: 10px;
    position: relative;

    &::before,
    &::after {
      // background: linear-gradient(135deg, $blue 0%, $green 100%);
      // border-radius: 1rem 1rem 0 1rem;
      // content: "";
      // left: -2rem;
      // overflow: hidden;
      // position: absolute;
      // width: 2rem;
    }

    &::before {
      // align-items: flex-end;
      // @extend %boxshadow;
      // content: counter(gradient-counter);
      // color: $black;
      // display: flex;
      // font: 500 1.5em/1 "Montserrat";
      // justify-content: flex-end;
      // padding: 0.125em 0.25em;
      // z-index: 1;
    }

    @for $i from 0 through 5 {
      &:nth-child(10n + #{$i}):before {
        background: linear-gradient(
          135deg,
          rgba($green, $i * 0.2) 0%,
          rgba($yellow, $i * 0.2) 100%
        );
      }
    }
    @for $i from 6 through 10 {
      &:nth-child(10n + #{$i}):before {
        background: linear-gradient(
          135deg,
          rgba($green, 1 - (($i - 5) * 0.2)) 0%,
          rgba($yellow, 1 - (($i - 5) * 0.2)) 100%
        );
      }
    }

    + li:hover {
      cursor: pointer;
    }

    + li {
      margin-top: 8px;
    }
  }
}

.textColor {
  color: #353535;
}
.pagination-circle-inner {
  position: absolute;
  width: 30px;
  height: 30px;
  background: #548cff;
  top: 20px;
  left: -35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  color: white;
}

.ban {
  width: 100%;
  height: 10vh;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ban img {
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

.ban .container {
  position: relative;
  z-index: 1;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
}

.site-section {
  padding-top: 0px;
}

.arrow-container {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
}

.arrow-1 {
  width: 100px;
  height: 100px;
  background: #00bcd4;
  opacity: 0.5;
  border-radius: 50%;
  position: absolute;
}

.arrow-2 {
  width: 60px;
  height: 60px;
  background: #00bcd4;
  border-radius: 50%;
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 1;
  display: table;
}

.arrow-2:before {
  width: 52px;
  height: 52px;
  content: "";
  border: 2px solid #006064;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
}

.arrow-2 i.fa {
  font-size: 30px;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  color: #006064;
}

/* Custom Animate.css */

.animated.hinge {
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}

@-webkit-keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.4, 0.4, 0.4);
    transform: scale3d(0.4, 0.4, 0.4);
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
  }
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    -webkit-transform: scale3d(0.4, 0.4, 0.4);
    transform: scale3d(0.4, 0.4, 0.4);
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 0;
  }
}

.zoomIn {
  -webkit-animation-name: zoomIn;
  animation-name: zoomIn;
}

.wrap {
  height: 100%;
  width: 100%;
  text-align: center;
}

img {
  height: 50px;
  width: auto;
}

.wrap img {
  margin: 0px 0 0 -40px;
  line-height: 60px;
  position: absolute;
  left: 50%;
  bottom: 0px;
}

.bounce {
  animation-iteration-count: infinite;
  animation-duration: 1.5s;
  animation: bounce 3.6s ease infinite;
  transform-origin: 50% 50%;
}

@keyframes bounce {
  0% {
    transform: translateY(0);
  }
  5.55556% {
    transform: translateY(0);
  }
  11.11111% {
    transform: translateY(0);
  }
  22.22222% {
    transform: translateY(-15px);
  }
  27.77778% {
    transform: translateY(0);
  }
  33.33333% {
    transform: translateY(-15px);
  }
  44.44444% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(0);
  }
}

.requirement {
  text-align: justify;
  letter-spacing: 1.2px;
}
</style>
